<template>
    <div class="d-flex justify-content-center tier-pricing m-1" v-if="!product.jewellery">
        <table
            class="table mb-0 text-start"
            :class="{ 'is-product-page': productPage }"
        >
            <thead class="fw-bold">
            <tr>
                <th class="pb-1">{{ $t('products.amount') }}</th>
                <th class="pb-1" v-if="showVat">{{ product.vat_status }}</th>
                <th class="pb-1"v-if="showVat && product.vat_percent > 0">{{ $t('Net') }}</th>
                <th class="pb-1 d-flex align-items-center" v-if="showPremium && product.premium_percent">
                    <span>{{ $t('products.premium') }}</span>
                    <PopoverMessage :message="$t('products.premium_text')"/>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(price, i) in quantityPrices"
                :key="i"
                :class="{
            'bg-success': activeQuantityPrice === price.quantity && hasQuantityPriceApplied
          }"
            >
                <td class="fw-bold">{{ price.quantity }}+</td>
                <td v-if="showVat">{{ $formatter.price(price.gross_price) }}</td>
                <td v-if="showVat && product.vat_percent > 0">{{ $formatter.price(price.net_price) }}</td>
                <td v-if="showPremium && price.premium_percent">
                    <span class="me-1">{{ $formatter.price(price.premium_value) }}</span>
                    <span>({{ $formatter.percent(price.premium_percent) }}%)</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
const PopoverMessage = defineAsyncComponent(() => import('~/components/PopoverMessage.vue'))

const props = defineProps({
    product: Object,
    showPremium: {
        type: Boolean,
        default: true,
    },
    showVat: {
        type: Boolean,
        default: true,
    },
    productPage: Boolean
});

const activeQuantityPrice = ref(null);
const hasQuantityPriceApplied = ref(false);
const quantityPrices = ref(props.product.quantity_prices);

if (quantityPrices.value.length === 0) {
    quantityPrices.value = [{
        quantity: 1,
        premium_value: props.product.premium_value,
        premium_percent: props.product.premium_percent
    }];
}
</script>

<style scoped>
.table-bold-lines {
    border-collapse: collapse;
}
.table-bold-lines th,
.table-bold-lines td {
    border: none !important;
}

.is-product-page th,
.is-product-page td {
    vertical-align: top;
    padding-left: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.tier-pricing .table tbody tr:last-child td {
    border-bottom: none;
}
</style>
